var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "2ae02aa04f28cc8896400c38750af939116e015e"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dodo-landing-page@delivery-hero-pm"] = {
  id: "2ae02aa04f28cc8896400c38750af939116e015e"
};